export type NotificationStatusColor = 'default' | 'info' | 'success' | 'error'

export type NotificationStatusDisplay = {
  label: string
  color: NotificationStatusColor
}

// Every value of event.notification_status, in the order the Gateway ranks an
// alert's status: the furthest a message got. A queued message outranks a
// failed one because it may still arrive. 'sent' means only that the provider
// accepted the message; delivery is 'received'.
const STATUSES: [string, NotificationStatusDisplay][] = [
  ['read', { label: 'נקרא', color: 'success' }],
  ['received', { label: 'נמסר', color: 'success' }],
  ['sent', { label: 'הועבר לספק', color: 'info' }],
  ['pending', { label: 'בהמתנה', color: 'default' }],
  ['failed', { label: 'נכשל', color: 'error' }],
  ['cancelled', { label: 'בוטל', color: 'default' }],
  ['skipped', { label: 'לא נשלח', color: 'default' }],
]
const DISPLAY = new Map(STATUSES)
const RANK = new Map(STATUSES.map(([status], rank) => [status, rank]))

/** A status the app does not know keeps the Gateway's name. */
export const describeNotificationStatus = (
  status: string
): NotificationStatusDisplay =>
  DISPLAY.get(status) ?? { label: status, color: 'default' }

/** Sorts the furthest status first; an unknown status sorts last. */
export const byDeliveryProgress = (a: string, b: string) =>
  (RANK.get(a) ?? STATUSES.length) - (RANK.get(b) ?? STATUSES.length)
